/**
 * Modes d'affichage d'une annonce.
 *
 * `displayMode` porte ce qu'a demandé l'administrateur et ne pilote que **le style**
 * (une annonce critique se présente autrement).
 * `effectiveDisplayMode` porte ce que le front doit faire, préférence utilisateur déjà
 * appliquée côté serveur, et ne vaut que `DISCRETE` ou `POPUP`.
 *
 * Le front ne rejoue jamais la règle de conversion : elle vit côté back.
 */
export enum AnnouncementDisplayModeEnum {
    DISCRETE = 'DISCRETE',
    POPUP = 'POPUP',
    CRITICAL = 'CRITICAL',
}
